import FingerprintJS from '@fingerprintjs/fingerprintjs'

// 加载指纹
const getFp = async function() {
  try {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    return result.visitorId
  } catch (e) {
    return ''
  }
}

export async function queryServer(url, callback, fp) {
  let temp_fp = fp
  if (temp_fp === '') {
    temp_fp = await getFp()
  }

  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        IDENTIFIER: temp_fp,
      },
    })

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`)
    }

    const json = await res.json()

    if (json.hasOwnProperty('detail')) {
      if (json.detail.indexOf('身份认证信息未提供') >= 0) {
        callback({
          data: {
            message: '指纹无效，请联系管理员添加指纹',
            fp: temp_fp,
          },
        })
      } else {
        callback({
          data: {
            message: '获取数据失败，请联系管理员',
            fp: temp_fp,
          },
        })
      }
    } else {
      if (json.errcode !== 200) {
        if (json.errcode === 401) {
          callback({
            data: {
              message: '该域下无此大屏模式',
              fp: temp_fp,
            },
          })
        } else {
          callback({
            data: {
              message: '获取数据失败，请联系管理员',
              fp: temp_fp,
            },
          })
        }
      } else {
        callback(json)
      }
    }
  } catch (reason) {
    callback({
      data: {
        message: '网络异常',
        fp: temp_fp,
      },
    })
  }
}
